import { render, staticRenderFns } from "./CollectionEditView.vue?vue&type=template&id=3bc9084c"
import script from "./CollectionEditView.vue?vue&type=script&lang=js"
export * from "./CollectionEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports